import { defineStore } from 'pinia'
import { useRouterUtils } from '@/composables/use-router-utils'
import { RouterName } from '@/enums/router-name'
import { api } from '@/services'
import { ErrorCode } from '~library/enums'

/** 平台 API 狀態檢查 */
export const useStatusStore = defineStore('status', () => {
  const router = useRouterUtils()

  /** API 是否已被檢查 */
  const _isApiChecked = ref<boolean>(false)

  /** API 是否已被檢查 */
  const isApiChecked = computed(() => {
    return _isApiChecked.value
  })

  /** 檢查 API 狀態 */
  const checkApiStatus = async () => {
    if (!_isApiChecked.value) {
      try {
        await api.commonUnAuth.getCheckPlatformStatus()
      } catch (error) {
        console.error(error)
        router.replace({
          name: RouterName.ERROR,
          params: {
            errorCode: ErrorCode.SYSTEM_MAINTAIN
          }
        })
      } finally {
        _isApiChecked.value = true
      }
    }
  }

  return {
    /** 檢查 API 狀態 */
    checkApiStatus,
    /** API 是否已被檢查 */
    isApiChecked
  }
})
